export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/switch-horizontal.8340a189.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};